import React from 'react';

const Bell = () => {
  return (
    <svg viewBox="0 0 39 45">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-156.000000, -964.000000)" stroke="currentColor" strokeWidth="2.5">
                <g transform="translate(173.123815, 986.447581) rotate(-17.000000) translate(-173.123815, -986.447581) translate(154.623815, 964.447581)">
                    <path d="M13.4773758,35.6194319 L13.4773758,39.0157468 C13.4773758,41.5582905 15.4920958,43.6194319 17.9773758,43.6194319 C20.4629256,43.6194319 22.4773758,41.5582905 22.4773758,39.0154708 L22.4773758,35.6194319 L13.4773758,35.6194319 Z"></path>
                    <path d="M21.1087981,5.36559316 L21.1087981,3.13780865 C21.1087981,1.40492962 19.7168577,0 18,0 C16.282861,0.000283938888 14.8909206,1.40492962 14.8909206,3.13780865 L14.8909206,5.36559316 C9.77101062,6.74837554 6,11.4609093 6,17.0647271 L6,26 L30,26 L30,17.0647271 C30,11.4609093 26.2287081,6.74837554 21.1087981,5.36559316 Z"></path>
                    <path d="M33.6323426,35.2599122 L2.51148395,35.2599122 C1.16404746,35.2599122 0.0717733701,34.2090374 0.0717733701,32.9129405 L0.0717733701,28.6068839 C0.0717733701,27.310787 1.16404746,26.2599122 2.51148395,26.2599122 L33.6323426,26.2599122 C34.9794993,26.2599122 36.0717734,27.310787 36.0717734,28.6068839 L36.0717734,32.9129405 C36.0717734,34.2090374 34.9794993,35.2599122 33.6323426,35.2599122 Z"></path>
                </g>
            </g>
        </g>
    </svg>
  )
}

export default Bell